import _classCallCheck from '../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import React from 'react';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner.es.js';
import { StyledButtonLoaderContainer, StyledLoaderAligner, StyledButtonChildren, StyledSquareButton, StyledFixedPillButton, StyledInlineButton, StyledTextButton, StyledGrayPillButton, StyledPillButton2, StyledPillButton } from './Button.styles.es.js';
import { renderIcon } from './renderIcon.es.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaultButtonProps = {
  shape: 'square',
  variant: 'primary',
  size: 'small',
  fullWidth: false,
  disabled: false,
  noBorderRadius: false,
  loading: false,
  loadingSpinnerProps: {}
};

var getColorOrDefault = function getColorOrDefault(variant, shape, propValue) {
  if (propValue && propValue.color) return propValue.color;
  if (variant !== 'primary') return 'blue';

  switch (shape) {
    case 'text':
      return 'blue';

    case 'inline':
      return 'blue';

    case 'gray-pill':
      return 'blue';

    default:
      return 'white';
  }
};

var getSizeOrDefault = function getSizeOrDefault(size, propValue) {
  if (propValue && propValue.size !== undefined) return propValue.size;

  switch (size) {
    case 'large':
      return 24;

    case 'small':
      return 20;

    default:
      return 18;
  }
};
/**
 * Renders a <Button /> component
 * @param {string} shape - set general shape of the button
 * @param {string} variant - set the color variant of the button.
 * @param {string} size - set the size of the button.
 * @param {boolean} fullWidth - set the width to 100% to parent container
 * @param {boolean} disabled - set the disabled property on button
 * @param {boolean} noBorderRadius - removes any border-radius if existing.
 * @param {boolean} withPulse - when explicitly set, triggers a pulse animation on the button
 * @param {boolean} animateIconRight - an optional param - set the animation on the right icon
 * @param {boolean} autoFocus - an optional param - currently not using in code
 * @param {React.ReactNode} children - an optional param - the children to be rendered inside the button
 * @param {boolean} className - an optional param - set the class on the element
 * @param {boolean} href - an optional param - set the href on the element
 * @param {React.ReactNode} iconLeft - an optional param - set the icon on the left of the element
 * @param {React.ReactNode} iconRight - an optional param - set the icon on the right of the element
 * @param {boolean} id - an optional param - set the id on the element
 * @param {boolean} label - an optional param - set the label of the button
 * @param {void} onClick - an optional param - set the onClick listener event on the element
 * @param {void} onKeyDown - an optional param - set the onKeyDown listener event on the element
 * @param {void} onKeyPress - an optional param - set the onKeyPress listener event on the element
 * @param {void} onKeyUp - an optional param - set the onKeyUp listener event on the element
 * @param {void} onMouseDown - an optional param - set the onMouseDown listener event on the element
 * @param {void} onMouseEnter - an optional param - set the onMouseEnter listener event on the element
 * @param {void} onMouseLeave - an optional param - set the onMouseLeave listener event on the element
 * @param {void} onMouseMove - an optional param - set the onMouseMove listener event on the element
 * @param {void} onMouseOut - an optional param - set the onMouseOut listener event on the element
 * @param {void} onMouseOver - an optional param - set the onMouseOver listener event on the element
 * @param {void} onMouseUp - an optional param - set the onMouseUp listener event on the element
 * @param {string} role - an optional param - set the role of the element
 * @param {CSSProperties} style - an optional param - set the style of the element
 * @param {number} tabIndex - an optional param - set the tabIndex of the element
 * @param {string} target - an optional param - set the target of the element
 * @param {string} title - an optional param - set the title of the element
 * @param {string} type - an optional param - set the type of the element
 *
 * [Documentation](https://mgmdigitalventures.atlassian.net/wiki/spaces/KB/pages/113640991/Styleguide+Gen+3.0+Room+Booking)
 */


var Button = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          shape = _this$props.shape,
          noBorderRadius = _this$props.noBorderRadius,
          variant = _this$props.variant,
          size = _this$props.size,
          fullWidth = _this$props.fullWidth,
          disabled = _this$props.disabled,
          loading = _this$props.loading,
          loadingLabel = _this$props.loadingLabel,
          loadingSpinnerProps = _this$props.loadingSpinnerProps,
          id = _this$props.id,
          className = _this$props.className,
          href = _this$props.href,
          _this$props$role = _this$props.role,
          role = _this$props$role === void 0 ? 'button' : _this$props$role,
          ariaLabel = _this$props.ariaLabel,
          target = _this$props.target,
          type = _this$props.type,
          title = _this$props.title,
          tabIndex = _this$props.tabIndex,
          autoFocus = _this$props.autoFocus,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          animateIconRight = _this$props.animateIconRight,
          label = _this$props.label,
          children = _this$props.children,
          onClick = _this$props.onClick,
          onMouseDown = _this$props.onMouseDown,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          onMouseMove = _this$props.onMouseMove,
          onMouseOut = _this$props.onMouseOut,
          onMouseOver = _this$props.onMouseOver,
          onMouseUp = _this$props.onMouseUp,
          onKeyDown = _this$props.onKeyDown,
          onKeyPress = _this$props.onKeyPress,
          onKeyUp = _this$props.onKeyUp,
          as = _this$props.as,
          style = _this$props.style,
          _this$props$withPulse = _this$props.withPulse,
          withPulse = _this$props$withPulse === void 0 ? false : _this$props$withPulse;
      var as1 = as !== undefined ? as : href ? 'a' : 'button';
      var type1 = type !== undefined ? type : as1 === 'button' ? 'button' : undefined;
      var buttonProps = {
        as: as1,
        fullWidth: fullWidth,
        shape: shape,
        noBorderRadius: noBorderRadius,
        disabled: disabled,
        href: href,
        role: role,
        ariaLabel: ariaLabel,
        target: target,
        type: type1,
        title: title,
        tabIndex: tabIndex,
        id: id,
        className: className,
        autoFocus: autoFocus,
        variant: variant,
        size: size,
        withPulse: withPulse,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onKeyUp: onKeyUp,
        style: style
      };
      var StyledButton;

      switch (shape) {
        case 'pill':
          StyledButton = StyledPillButton;
          break;

        case 'half-pill':
          StyledButton = StyledPillButton2;
          break;

        case 'gray-pill':
          StyledButton = StyledGrayPillButton;
          break;

        case 'text':
          StyledButton = StyledTextButton;
          break;

        case 'inline':
          StyledButton = StyledInlineButton;
          break;

        case 'fixed-pill':
          StyledButton = StyledFixedPillButton;
          break;

        default:
          StyledButton = StyledSquareButton;
          break;
      }

      var buttonChildren = children || /*#__PURE__*/React.createElement(React.Fragment, null, iconLeft && renderIcon(iconLeft, {
        align: 'left'
      }), label && /*#__PURE__*/React.createElement("span", null, label), iconRight && renderIcon(iconRight, {
        align: 'right',
        animateIconRight: animateIconRight
      }));
      return /*#__PURE__*/React.createElement(StyledButton, Object.assign({}, buttonProps, {
        "aria-label": loading ? loadingLabel : ariaLabel,
        "data-testid": this.props['data-testid']
      }), loading && /*#__PURE__*/React.createElement(StyledButtonLoaderContainer, null, /*#__PURE__*/React.createElement(StyledLoaderAligner, null, /*#__PURE__*/React.createElement(LoadingSpinner, Object.assign({}, loadingSpinnerProps, {
        size: getSizeOrDefault(size, loadingSpinnerProps),
        color: getColorOrDefault(variant, shape, loadingSpinnerProps)
      })))), /*#__PURE__*/React.createElement(StyledButtonChildren, {
        "$loading": loading,
        className: "buttonChildren"
      }, buttonChildren), /*#__PURE__*/React.createElement("div", {
        "ripple-effect": "true"
      }));
    }
  }], [{
    key: "selector",
    value: function selector(label) {
      return "Button:".concat(label);
    }
  }]);

  return Button;
}(React.PureComponent);
Button.defaultProps = defaultButtonProps;

export { Button, defaultButtonProps };
